import { SignPad, SignPadRef } from 'components/SignPad/SignPad';
import { Button } from 'components/UI/Button/Button';
import Modal, { ModalProps } from 'components/UI/Modal/Modal';
import React from 'react';
import { Agreement, PendingAgreementSignature } from 'types/Agreement';

import classes from 'components/Agreements/SignModal/AgeeementSignModal.module.scss';

export type AgreementModalProps = Omit<ModalProps, 'footer' | 'open' | 'title' | 'children'> & {
    open: boolean;
    agreement: Agreement;
    onSign: (signature: PendingAgreementSignature) => void;
};

const convertToFile = async (url: string, fileName: string): Promise<File> => {
    return fetch(url)
        .then(res => res.blob())
        .then(blob => {
            return new File([blob], fileName, { type: 'image/png' });
        });
};

export const AgreementModal: React.FC<AgreementModalProps> = props => {
    const signRef = React.useRef<SignPadRef>(null);

    const [isInvalid, setIsInvalid] = React.useState<boolean>(true);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);

    const clearHandler = () => {
        if (signRef) {
            signRef.current?.clear();
            signPadChangeHandler();
        }
    };

    const signPadChangeHandler = () => {
        setIsInvalid(signRef?.current?.isEmpty() as boolean);
    };

    const confirmHandler = async () => {
        setIsLoading(true);

        try {
            const file = await convertToFile(
                signRef?.current?.getTrimmedCanvas().toDataURL('image/png') as string,
                `signature_${props.agreement.id}.png`
            );

            props.onSign({
                agreementId: props.agreement.id,
                customerSignature: file
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Modal
                open={props.open}
                title={props.agreement.title}
                footer={
                    <div className={classes.footer}>
                        <div className={classes.signPadHeader}>
                            <p>Sign Here</p>

                            <button onClick={clearHandler}>Clear</button>
                        </div>

                        <SignPad ref={signRef} onChange={signPadChangeHandler} />

                        <Button
                            variant="green"
                            loading={isLoading}
                            disabled={isInvalid || isLoading}
                            id="agreement_confirm"
                            onClick={confirmHandler}
                        >
                            Confirm
                        </Button>
                    </div>
                }
                onClose={props.onClose}
            >
                <div dangerouslySetInnerHTML={{ __html: props.agreement.content }}></div>
            </Modal>
        </>
    );
};
